import React from "react";
import { titleCase } from "@/lib/format";

const COLLECTION_STYLES = {
  completed: "bg-emerald-50 text-emerald-800 border-emerald-200",
  approved: "bg-emerald-50 text-emerald-800 border-emerald-200",
  pending: "bg-amber-50 text-amber-900 border-amber-200",
  scheduled: "bg-amber-50 text-amber-900 border-amber-200",
  in_progress: "bg-sky-50 text-sky-800 border-sky-200",
  started: "bg-sky-50 text-sky-800 border-sky-200",
  awaiting_review: "bg-violet-50 text-violet-800 border-violet-200",
  missed: "bg-rose-50 text-rose-800 border-rose-200",
  failed: "bg-rose-50 text-rose-800 border-rose-200",
  cancelled: "bg-slate-100 text-slate-600 border-slate-200",
  rejected: "bg-rose-50 text-rose-800 border-rose-200",
};

const INVOICE_STYLES = {
  paid: "bg-emerald-50 text-emerald-800 border-emerald-200",
  authorised: "bg-sky-50 text-sky-800 border-sky-200",
  submitted: "bg-sky-50 text-sky-800 border-sky-200",
  sent: "bg-sky-50 text-sky-800 border-sky-200",
  draft: "bg-slate-100 text-slate-600 border-slate-200",
  overdue: "bg-rose-50 text-rose-800 border-rose-200",
  voided: "bg-slate-100 text-slate-500 border-slate-200",
};

export const StatusBadge = ({ status, type = "collection", testId }) => {
  const key = (status || "").toLowerCase();
  const map = type === "invoice" ? INVOICE_STYLES : COLLECTION_STYLES;
  const cls = map[key] || "bg-slate-100 text-slate-600 border-slate-200";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${cls}`}
    >
      {titleCase(status || "unknown")}
    </span>
  );
};

export default StatusBadge;
